import React, { lazy } from 'react';

import {
	AdminIcon,
	AlignIcon,
	BambooIcon,
	BitbucketIcon,
	CompassIcon,
	ConfluenceDataCenterIcon,
	ConfluenceIcon,
	CustomerServiceManagementIcon,
	FocusIcon,
	HomeIcon,
	JiraDataCenterIcon,
	JiraIcon,
	JiraServiceManagementIcon,
	TrelloIcon,
} from '@atlaskit/logo';
import Suspense from '@atlaskit/react-ufo/suspense';

import { type RovoLogo } from './icons/RovoLogo';
import { RovoLogoFromLogo } from './icons/RovoLogoFromLogo';
import { type RovoLogoProps } from './icons/RovoLogoProps';

const Lazy3PLogoWrapper = lazy(() =>
	import('./3p-product-configs').then((module) => ({ default: module.Lazy3PLogoWrapper })),
);

const ProductKeysToLogoMap = new Map<string, RovoLogo>([
	['jira', RovoLogoFromLogo(JiraIcon)],
	['confluence', RovoLogoFromLogo(ConfluenceIcon)],
	['bamboo', RovoLogoFromLogo(BambooIcon)],
	['focus', RovoLogoFromLogo(FocusIcon)],
	['compass', RovoLogoFromLogo(CompassIcon)],
	['jsm', RovoLogoFromLogo(JiraServiceManagementIcon)],
	['admin', RovoLogoFromLogo(AdminIcon)],
	['align', RovoLogoFromLogo(AlignIcon)],
	['bitbucket', RovoLogoFromLogo(BitbucketIcon)],
	['jira_dc', RovoLogoFromLogo(JiraDataCenterIcon)],
	['confluence_dc', RovoLogoFromLogo(ConfluenceDataCenterIcon)],
	['trello', RovoLogoFromLogo(TrelloIcon)],
	['atlas', RovoLogoFromLogo(HomeIcon)],
	['help_aggregator', RovoLogoFromLogo(CustomerServiceManagementIcon)],
]);

export function RovoLogoForAppSource({
	appSource,
	rovoLogoProps,
	fallback,
}: {
	appSource: string;
	rovoLogoProps: RovoLogoProps;
	fallback?: React.ReactNode;
}): React.ReactNode | null {
	const productLogo = ProductKeysToLogoMap.get(appSource);
	if (productLogo) {
		const Logo = productLogo as RovoLogo;
		return <Logo {...rovoLogoProps} />;
	}
	return (
		<Suspense
			interactionName="rovo-conversation-assistant-rovo-logo-for-app-source"
			fallback={fallback}
		>
			<Lazy3PLogoWrapper appSource={appSource} rovoLogoProps={rovoLogoProps} fallback={fallback} />
		</Suspense>
	);
}
